import _sfc_main from "./component-library194.mjs";
import "./component-library195.mjs";
import normalizeComponent from "./component-library81.mjs";
var _sfc_render = function render() {
  var _a, _b, _c2, _d, _e;
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.componentTag, { tag: "component", staticClass: "card", class: _setup.cardClasses, style: _vm.customStyles, attrs: { "role": _vm.role, "href": _setup.componentTag === "a" ? _vm.href : void 0, "to": _setup.componentTag !== "a" ? _vm.href : void 0, "target": _vm.isExternal ? "_blank" : void 0 }, on: { "click": _setup.onClick } }, [_c("div", { staticClass: "card__background" }, [_vm._t("background", function() {
    var _a2;
    return [((_a2 = _vm.background) == null ? void 0 : _a2.src) ? _c(_setup.PictureElement, _vm._b({}, "PictureElement", _vm.background, false)) : _vm._e()];
  })], 2), _vm.$slots.image || ((_a = _vm.image) == null ? void 0 : _a.src) ? _c("div", { staticClass: "card__image" }, [_c("div", { staticClass: "card__image-container", class: `card__image-container--${_vm.imagePosition}` }, [_vm._t("image", function() {
    var _a2;
    return [((_a2 = _vm.image) == null ? void 0 : _a2.src) ? _c(_setup.PictureElement, _vm._b({}, "PictureElement", _vm.image, false)) : _vm._e()];
  })], 2), _vm.$slots.imageBadge ? _c("div", { staticClass: "card__image-badge" }, [_vm._t("imageBadge")], 2) : _vm._e()]) : _vm._e(), _c("div", { staticClass: "card__container" }, [_vm.$slots.label || ((_b = _vm.label) == null ? void 0 : _b.text) ? _c("div", { staticClass: "card__label" }, [_vm._t("label", function() {
    var _a2;
    return [((_a2 = _vm.label) == null ? void 0 : _a2.text) ? _c(_setup.Paragraph, _vm._b({ attrs: { "no-margin": "" } }, "Paragraph", _vm.label, false)) : _vm._e()];
  })], 2) : _vm._e(), _vm.$slots.heading || ((_c2 = _vm.heading) == null ? void 0 : _c2.text) ? _c("div", { staticClass: "card__heading" }, [_vm._t("heading", function() {
    var _a2;
    return [((_a2 = _vm.heading) == null ? void 0 : _a2.text) ? _c(_setup.Heading, _vm._b({}, "Heading", _vm.heading, false)) : _vm._e()];
  })], 2) : _vm._e(), _vm.$slots.subtitle || ((_d = _vm.subtitle) == null ? void 0 : _d.text) ? _c("div", { staticClass: "card__subtitle" }, [_vm._t("subtitle", function() {
    var _a2;
    return [((_a2 = _vm.subtitle) == null ? void 0 : _a2.text) ? _c(_setup.Paragraph, _vm._b({}, "Paragraph", _vm.subtitle, false)) : _vm._e()];
  })], 2) : _vm._e(), _c("div", { staticClass: "card__content" }, [_vm._t("default", function() {
    return [_c("span", { domProps: { "innerHTML": _vm._s(_vm.text) } })];
  })], 2), _vm.$slots.action || ((_e = _vm.buttons) == null ? void 0 : _e.length) > 0 ? _c("div", { staticClass: "card__action" }, [_vm._t("action", function() {
    return _vm._l(_vm.buttons, function(button, key) {
      return _c(_setup.LinkButton, _vm._b({ key }, "LinkButton", button, false));
    });
  })], 2) : _vm._e()])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "77f8a578",
  null,
  null
);
const Card = __component__.exports;
export {
  Card as default
};
